import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import {
  DateRangePicker,
  GuestPicker,
  useHotelShopSearch,
} from "@tenant/hotels";
import clsx from "clsx";

import defaultStyles from "./HotelShopSearch.module.scss";

export type HotelShopSearchComponentProps = PlatformComponentProps;
export const HotelShopSearch = ({
  children,
  className,
}: HotelShopSearchComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelShopSearch;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useHotelShopSearch();

  return (
    <div className={clsx(block, className)}>
      <DateRangePicker
        startDate={context.dateRange.from}
        endDate={context.dateRange.until}
        onStartDateChangeHandler={(date) => {
          handlers.handleDateRangeFromChange(date);
        }}
        onEndDateChangeHandler={(date) => {
          handlers.handleDateRangeUntilChange(date);
        }}
        onDoneClick={handlers.handleDateRangeClose}
      />

      <GuestPicker
        guests={context.guests}
        rooms={context.rooms}
        onGuestSelectionHandler={handlers.onGuestSelection}
      />
      {children}
    </div>
  );
};
